module.exports = __webpack_public_path__ + "img/member.93815dda.svg";